// extracted by mini-css-extract-plugin
module.exports = {"container":"Upload_container_35G9y","dropArea":"Upload_dropArea_3CNe6","result":"Upload_result_o8ceI","resultTable":"Upload_resultTable_2TVZE"};